module.exports = __webpack_public_path__ + "static/media/hsbc_logo_sc.8cd5168f.svg";